import { toast } from "react-toastify";
import { BAD_FIT_RESOLUTION_REASON } from "../config/apiEndPoint";
import { GET, POST, PUT } from "config/api.config";

export const fetchBadFitResolutionReasonTableAndFilterSchema = async (data = {}) => {
  try {
    const response = await GET(BAD_FIT_RESOLUTION_REASON.METADATA, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const submitFilterData = async (data = {}) => {
  try {
    const response = await POST(BAD_FIT_RESOLUTION_REASON.FILTER, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const addBadFitResolutionReason = async (data = {}) => {
  try {
    const response = await POST(BAD_FIT_RESOLUTION_REASON.LIST, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const updateBadFitResolutionReason = async (id, data = {}) => {
  try {
    const response = await PUT(BAD_FIT_RESOLUTION_REASON.BY_ID(id), data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const getBadFitResolutionReasonDataById = async (data = {}) => {
  try {
    const id = data?.Id ?? data?.id;
    const response = await GET(BAD_FIT_RESOLUTION_REASON.BY_ID(id), data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};
